export const WIZARD_ERROR_MESSAGE = "_WizardTitleErrorMessage";
// export const WIZARD_TAB_STATUS = "_WizardTabStatus";

// TODO: clean up, no needed after removing TabForms
// export const MAJORS = "majors";

// export const STATUS_CLEAR = "clear";
// export const STATUS_DIRTY = "dirty";
// export const STATUS_SAVED = "saved";
// export const STATUS_ERROR = "error";
